/* eslint-disable */
export default {
  createCallLog: 'Créer journ. d’appels',
  viewInSalesforce: 'Afficher dans Salesforce',
  createLog: 'Créer un journal',
} as const;

// @key: @#@"createCallLog"@#@ @source: @#@"Create call log"@#@
// @key: @#@"viewInSalesforce"@#@ @source: @#@"View in Salesforce"@#@
// @key: @#@"createLog"@#@ @source: @#@"Create log"@#@
